import styled from "styled-components";

import { Button, Flex } from "@olist/design-system";

export const Container = styled(Flex)`
  color: ${({ theme }) => theme.olist.components.text.color};
  margin: 0 auto;
  padding-bottom: 64px;
  flex-direction: column;

  p,
  a,
  ul > li,
  ol > li {
    font-family: ${({ theme }) =>
      theme.olist.components.text.paragraphMd.default.desktop.fontFamily};
    font-size: ${({ theme }) =>
      theme.olist.components.text.paragraphMd.default.desktop.fontSize};
    font-weight: ${({ theme }) =>
      theme.olist.components.text.paragraphMd.default.desktop.fontWeight};
    letter-spacing: ${({ theme }) =>
      theme.olist.components.text.paragraphMd.default.desktop.letterSpacing};
    line-height: ${({ theme }) =>
      theme.olist.components.text.paragraphMd.default.desktop.lineHeight};
  }

  strong {
    font-weight: bold;
  }

  p:has(mark) {
    border-radius: 4px;
    width: 100%;
    padding: 16px;
  }
  p:has(mark.marker-pink),
  .marker-pink {
    background-color: ${({ theme }) =>
      theme.olist.components.alert.variation.error.background};
    color: ${({ theme }) => theme.olist.components.alert.variation.error.color};
  }

  p:has(mark.marker-blue),
  .marker-blue {
    background-color: ${({ theme }) =>
      theme.olist.components.alert.variation.primary.background};
  }

  p:has(mark.marker-yellow),
  .marker-yellow {
    background-color: ${({ theme }) =>
      theme.olist.components.alert.variation.alert.background};
  }

  p:not(:is(ul p, li p)) {
    margin: 8px 0 12px;
  }

  ul {
    list-style-type: disc;
    padding-left: 3rem;
  }

  p:has(img) {
    display: flex;
    justify-content: center;
    margin-bottom: 24px !important;
  }

  img {
    max-width: 100%;
    display: block;
    margin: auto;
  }

  h1 {
    // 3rem = 48px
    font-size: 2.5rem;
    line-height: 3rem;
    font-family: ${({ theme }) =>
      theme.olist.components.text.title.default.desktop.fontFamily};
    font-weight: ${({ theme }) =>
      theme.olist.components.text.title.default.desktop.fontWeight};
    letter-spacing: ${({ theme }) =>
      theme.olist.components.text.title.default.desktop.letterSpacing};
    color: ${({ theme }) => theme.olist.color.neutral.stronger};
    margin: 28px 0;

    & > a {
      font-family: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
      letter-spacing: inherit !important;
      line-height: inherit !important;

      text-decoration: none !important;

      &:visited {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.rest} !important;
      }

      &:hover {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.hover} !important;
      }
    }
  }

  h2 {
    // 2.5rem = 40px
    font-size: 2rem;
    line-height: 2.5rem;
    font-family: ${({ theme }) =>
      theme.olist.components.text.sectionHeading.default.desktop.fontFamily};
    font-weight: ${({ theme }) =>
      theme.olist.components.text.sectionHeading.default.desktop.fontWeight};
    letter-spacing: ${({ theme }) =>
      theme.olist.components.text.sectionHeading.default.desktop.letterSpacing};
    color: ${({ theme }) => theme.olist.color.primary.base};

    margin: 28px 0;

    & > a {
      font-family: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
      letter-spacing: inherit !important;
      line-height: inherit !important;

      text-decoration: none !important;

      &:visited {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.rest} !important;
      }

      &:hover {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.hover} !important;
      }
    }
  }

  h3 {
    // 2rem = 32px
    font-size: 1.5rem;
    line-height: 2rem;
    font-family: ${({ theme }) =>
      theme.olist.components.text.sectionSubheading.default.desktop.fontFamily};
    font-weight: ${({ theme }) =>
      theme.olist.components.text.sectionSubheading.default.desktop.fontWeight};
    letter-spacing: ${({ theme }) =>
      theme.olist.components.text.sectionSubheading.default.desktop
        .letterSpacing};
    color: ${({ theme }) => theme.olist.color.primary.base};

    margin: 28px 0 10px;

    & > a {
      font-family: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
      letter-spacing: inherit !important;
      line-height: inherit !important;

      text-decoration: none !important;

      &:visited {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.rest} !important;
      }

      &:hover {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.hover} !important;
      }
    }
  }

  h4 {
    // 1.5rem = 24px
    font-size: 1.125rem;
    line-height: 1.5rem;
    font-family: ${({ theme }) =>
      theme.olist.components.text.detailedSubheading.default.desktop
        .fontFamily};
    font-weight: ${({ theme }) =>
      theme.olist.components.text.detailedSubheading.default.desktop
        .fontWeight};
    letter-spacing: ${({ theme }) =>
      theme.olist.components.text.detailedSubheading.default.desktop
        .letterSpacing};
    color: ${({ theme }) => theme.olist.color.primary.base};

    margin: 28px 0 10px;

    & > a {
      font-family: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
      letter-spacing: inherit !important;
      line-height: inherit !important;

      text-decoration: none !important;

      &:visited {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.rest} !important;
      }

      &:hover {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.hover} !important;
      }
    }
  }

  h5,
  h6 {
    // 1.125rem = 18px
    font-size: 1.125rem;
    line-height: 1.125rem;
    font-weight: 600;
    font-family: ${({ theme }) =>
      theme.olist.components.text.paragraphLg.default.desktop.fontFamily};
    letter-spacing: ${({ theme }) =>
      theme.olist.components.text.paragraphLg.default.desktop.letterSpacing};
    color: ${({ theme }) => theme.olist.color.primary.base};

    margin: 28px 0 10px;

    & > a {
      font-family: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
      letter-spacing: inherit !important;
      line-height: inherit !important;

      text-decoration: none !important;

      &:visited {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.rest} !important;
      }

      &:hover {
        color: ${({ theme }) =>
          theme.olist.components.link.colors.hover} !important;
      }
    }
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 30px;
      line-height: 30px;
    }

    h2 {
      font-size: 25px;
      line-height: 25px;
    }

    h3 {
      font-size: 20px;
      line-height: 20px;
    }

    h4 {
      font-size: 18px;
      line-height: 18px;
    }

    h5 {
      font-size: 16px;
      line-height: 16px;
    }
  }

  @media (max-width: 1024px) {
    figure.table,
    table {
      max-width: 90vw;
      overflow-x: auto;
    }
  }

  a {
    color: ${({ theme }) => theme.olist.components.link.colors.rest};
    font-family: ${({ theme }) => theme.olist.components.link["font-family"]};
    font-weight: ${({ theme }) => theme.olist.components.link["font-weight"]};
    letter-spacing: ${({ theme }) =>
      theme.olist.components.link["letter-spacing"]};
    line-height: ${({ theme }) => theme.olist.components.link["line-height"]};
    width: fit-content;

    &:hover {
      color: ${({ theme }) => theme.olist.components.link.colors.hover};
    }

    &:focus {
      color: ${({ theme }) => theme.olist.components.link.colors.focus};
    }

    &:active {
      color: ${({ theme }) => theme.olist.components.link.colors.active};
    }

    &:visited {
      color: ${({ theme }) => theme.olist.components.link.colors.visited};
    }
  }

  ol {
    list-style-type: decimal;
    padding-left: 3rem;
  }

  li {
    margin-bottom: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 1rem;
    text-align: left;

    th,
    td {
      padding: 12px 15px;
      border: 1px solid #ddd;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }
  }

  // exception for freigth table
  table > tbody > tr > td:nth-child(1) {
    height: 22px !important;
  }

  // exception for tiny tables
  div.panel-body {
    table > tbody > tr > td {
      max-width: 330px !important;
      min-width: 80px !important;
      padding: 0 12px;
      width: fit-content !important;

      > * > a,
      > a {
        text-decoration: none !important;
      }
    }
  }

  .media {
    display: flex;
    justify-content: center;

    iframe {
      width: 90%;
      height: 340px;
    }
  }

  .video-frame {
    display: flex;
    justify-content: center;

    iframe {
      max-width: 90%;
      min-height: 340px;
    }
  }

  .image {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bs-callout,
  .bs-callout-info {
    background-color: ${({ theme }) =>
      theme.olist.components.alert.variation.primary.background};
    color: ${({ theme }) =>
      theme.olist.components.alert.variation.primary.color};
    border-radius: 4px;
    width: 100%;
    padding: 16px !important;
    margin: 12px 0;
  }

  .olist-alert-info,
  .olist-alert-warning,
  .olist-alert-error {
    border-radius: 4px;
    width: 100%;
    padding: 16px !important;
    margin: 12px 0;
  }

  .olist-alert-info,
  .marker-blue {
    background-color: ${({ theme }) =>
      theme.olist.components.alert.variation.primary.background};
    color: ${({ theme }) =>
      theme.olist.components.alert.variation.primary.color};
  }

  .olist-alert-warning,
  .marker-yellow {
    background-color: ${({ theme }) =>
      theme.olist.components.alert.variation.alert.background};
    color: ${({ theme }) => theme.olist.components.alert.variation.alert.color};
  }

  .olist-alert-error,
  .marker-pink {
    background-color: ${({ theme }) =>
      theme.olist.components.alert.variation.error.background};
    color: ${({ theme }) => theme.olist.components.alert.variation.error.color};
  }
`;

export const EvaluationRow = styled(Flex)`
  align-items: center;
  border: 1px solid ${({ theme }) => theme.olist.color.neutral.softer};
  border-radius: 12px;
  justify-content: space-between;
  padding: 0 24px;
`;

export const SButton = styled(Button)`
  border: none;
  color: ${({ theme }) => theme.olist.color.primary.base};
`;
